import { useGetQualifications } from "@src/appV2/Qualifications/api/useGetQualifications";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useHistory, useParams } from "react-router-dom";

import { type RoleRemovedModalRouteParams } from "../../types";
import { RoleRemovedBottomSheet } from "./RemovedBottomSheet";

interface RoleRemovedBottomSheetContainerProps {
  modalState: UseModalState;
}

export function RoleRemovedBottomSheetContainer(props: RoleRemovedBottomSheetContainerProps) {
  const { modalState } = props;

  const { qualificationId } = useParams<RoleRemovedModalRouteParams>();

  const { data: qualifications } = useGetQualifications({
    enabled: true,
  });

  const qualificationName = qualifications?.data.find(
    (qualification) => qualification.id === qualificationId
  )?.attributes.displayLabel;

  const history = useHistory();

  modalState.closeModal = () => {
    history.goBack();
    modalState.setModalStatus("closed");
  };

  return (
    <RoleRemovedBottomSheet modalState={modalState} qualificationName={qualificationName ?? ""} />
  );
}
